<template>
  <b-container fluid id="StartReceive">
    <b-row align-v="center">
      <b-col class="col-12 col-md-5">
        <h3 class="mb-5">
          Best practices for engaging and influencing others on virtual meetings
        </h3>
        <div class="content-center">
          <TMGeneralButton
            text="START TO RECEIVE FEEDBACK"
            route="GetStarted"
            class="blue"
            className="action"
          />
        </div>
      </b-col>
      <b-col class="col-12 col-md-7 text-right">
        <img
          src="/img/how-it-works/bigstock-Video-Call-Group-Business-Peop-369239866.png"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
export default {
  name: "StartReceive",
  components: {
    TMGeneralButton,
  },
};
</script>
<style lang="less" >
@import "../../assets/components/howItWorks/StartReceive.less";
</style>;